import React, { useReducer, createContext, Dispatch, ReactNode } from 'react';
import { ThirdNavChildrenType } from '../modules/ThirdNav/ThirdNav.controller';
import { OnClosePostEditorAction } from './AppProvider';

export type TopNavStateType = {
  visibility: TopNavVisibility;
  thirdNavChildren: undefined | ThirdNavChildrenType;
  newPostCloseCallback: undefined | OnClosePostEditorAction;
};

export type TopNavVisibility = {
  top: boolean;
  second: boolean;
  third: boolean;
};

type NavigationType = {
  NavigationPositionType: 'top' | 'second' | 'third';
  NavigationVisibilityType: 'hide' | 'show';
};

const InitialState: TopNavStateType = {
  visibility: {
    top: false,
    second: false,
    third: false
  },
  thirdNavChildren: undefined,
  newPostCloseCallback: undefined
};

type ReducerAction =
  | { type: 'updateVisibility'; payload: NavigationType }
  | { type: 'updateThirdNavChildren'; payload: undefined | ThirdNavChildrenType }
  | { type: 'setNewPostCloseCallback'; payload: undefined | OnClosePostEditorAction };

export const TopNavContext = createContext<{
  state: TopNavStateType;
  dispatch: Dispatch<ReducerAction>;
}>({
  state: InitialState,
  dispatch: () => {
    /**/
  }
});

const reducer = (state: TopNavStateType, action: ReducerAction): TopNavStateType => {
  switch (action.type) {
    case 'updateVisibility':
      return {
        ...state,
        visibility: {
          ...state.visibility,
          [action.payload['NavigationPositionType']]: action.payload.NavigationVisibilityType === 'show'
        }
      };
    case 'updateThirdNavChildren':
      return {
        ...state,
        thirdNavChildren: action.payload
      };
    case 'setNewPostCloseCallback':
      return {
        ...state,
        newPostCloseCallback: action.payload
      };
    default:
      // TODO: add (future) JS logging instead of throw
      throw new Error();
  }
};

export const TopNavProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const [state, dispatch] = useReducer(reducer, InitialState);

  return <TopNavContext.Provider value={{ state, dispatch }}>{children}</TopNavContext.Provider>;
};
